<template>
  <div class="nav-header" :class="{bg}">
    <div class="g-container wrapper">
      <a class="g-link-clear" href="/">
        <img class="img--logo" src="../assets/logo.svg" alt="logo">
      </a>
      <nav class="nav">
        <template v-if="nav">
          <LinkBox class="nav__item">
            <a class="g-font-mid g-link-clear" href="#card-solution">{{ $t('nav.nav1') }}</a>
          </LinkBox>
          <LinkBox class="nav__item">
            <a class="g-font-mid g-link-clear" href="#payment-gateway">{{ $t('nav.nav2') }}</a>
          </LinkBox>
          <LinkBox class="nav__item">
            <a class="g-font-mid g-link-clear" href="#payment">{{ $t('nav.nav3') }}</a>
          </LinkBox>
          <LinkBox class="nav__item">
            <a class="g-font-mid g-link-clear" href="https://github.com/railone-io/railone-docs">{{ $t('nav.nav4') }}</a>
          </LinkBox>
        </template>
      </nav>
      <ButtonCreate class="btn--create" />
    </div>
  </div>
</template>

<script>
import ButtonCreate from '@/components/ButtonCreate.vue';
import LinkBox from '@/components/LinkBox.vue';

export default {
  name: 'NavHeader',
  components: { LinkBox, ButtonCreate },
  props: {
    nav: {
      type: Boolean,
      require: false,
      default: true,
    },
  },
  data() {
    return {
      bg: false,
    };
  },
  methods: {
    handleScroll() {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      this.bg = top !== 0;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .nav-header {
    z-index: 2;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: $header-height;
    line-height: $header-height;

    &.bg {
      background: #FFF;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .img--logo {
    vertical-align: middle;
    height: 24px;
  }

  .nav {
    flex: 1;
    text-align: center;
    white-space: nowrap;
    overflow: auto;
  }

  .nav__item {
    font-size: 16px;
    line-height: 19px;
    opacity: .8;
    transition: opacity .3s;

    & + & {
      margin-left: 48px;
    }

    &:hover {
      opacity: 1;
    }
  }

  .btn--create {
    @media (max-width: 960px) {
      display: none;
    }
  }
</style>
